"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _SimpleStyledCaret = _interopRequireDefault(require("../internal/SimpleStyledCaret"));

var _SimpleStyledClickable = _interopRequireDefault(require("../internal/SimpleStyledClickable"));

var _UIIconButton = _interopRequireDefault(require("../../button/UIIconButton"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _UIAbstractDropdown = _interopRequireDefault(require("../../dropdown/abstract/UIAbstractDropdown"));

var _UITextToolbarIcon = _interopRequireDefault(require("../../editor/UITextToolbarIcon"));

var _UIList = _interopRequireDefault(require("../../list/UIList"));

var _OptionTypes = require("../../types/OptionTypes");

var _Dom = require("../../utils/Dom");

var _underscore = require("../../utils/underscore");

var getDropdownClassName = function getDropdownClassName(dropdownClassName) {
  return (0, _classnames.default)('private-dropdown--list', dropdownClassName);
};

var UIAbstractIconDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIAbstractIconDropdown, _Component);

  function UIAbstractIconDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAbstractIconDropdown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAbstractIconDropdown).call(this, props));

    _this.handleKeyDown = function (evt) {
      var key = evt.key;
      var open = _this.props.open;
      if (!open) return;

      if (key === 'ArrowDown' || key === 'ArrowUp') {
        var menu = document.getElementById(_this._id);
        if (!menu) return;

        if ((0, _Dom.moveFocusToNext)('li', menu, key === 'ArrowUp')) {
          evt.preventDefault();
        }

        evt.stopPropagation();
      }
    };

    _this._id = "icon-dropdown-" + (0, _underscore.uniqueId)();
    _this.getHandleChange = (0, _memoize.default)(_this.getHandleChange.bind((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(UIAbstractIconDropdown, [{
    key: "getHandleChange",
    value: function getHandleChange(value) {
      var _this2 = this;

      var event = (0, _SyntheticEvent.default)(value);
      return function () {
        var _this2$props = _this2.props,
            onOpenChange = _this2$props.onOpenChange,
            onChange = _this2$props.onChange,
            open = _this2$props.open;
        onChange(event);
        onOpenChange((0, _SyntheticEvent.default)(!open));
      };
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(options) {
      var _this3 = this;

      return options.map(function (_ref) {
        var icon = _ref.icon,
            value = _ref.value;
        return _react.default.createElement(_UIIconButton.default, {
          key: icon,
          onClick: _this3.getHandleChange(value),
          placement: "left",
          use: "unstyled"
        }, _react.default.createElement(_UITextToolbarIcon.default, {
          name: icon
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dropdownClassName = _this$props.dropdownClassName,
          open = _this$props.open,
          options = _this$props.options,
          __value = _this$props.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["dropdownClassName", "open", "options", "value"]);
      var computedDropdownClassName = getDropdownClassName(dropdownClassName);
      return _react.default.createElement(_UIAbstractDropdown.default, Object.assign({}, rest, {
        Button: _SimpleStyledClickable.default,
        caretRenderer: _react.default.createElement(_SimpleStyledCaret.default, null),
        dropdownClassName: computedDropdownClassName,
        menuWidth: 50,
        open: open,
        onKeyDown: this.handleKeyDown
      }), _react.default.createElement(_UIList.default, {
        id: this._id
      }, this.renderOptions(options)));
    }
  }]);
  return UIAbstractIconDropdown;
}(_react.Component);

UIAbstractIconDropdown.propTypes = Object.assign({}, _UIAbstractDropdown.default.propTypes, {
  defaultValue: _OptionTypes.SingleValueType,
  dropdownClassName: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _UITextToolbarIcon.default.propTypes.name,
    value: _OptionTypes.SingleValueType
  }).isRequired).isRequired,
  value: _OptionTypes.SingleValueType
});
UIAbstractIconDropdown.defaultProps = Object.assign({}, _UIAbstractDropdown.default.defaultProps, {
  open: false
});
UIAbstractIconDropdown.displayName = 'UIAbstractIconDropdown';
var _default = UIAbstractIconDropdown;
exports.default = _default;
module.exports = exports.default;